class collectionSubcategories extends HTMLElement {
  static observedAttributes = ["data-current-url"];
  constructor() {
    super();
    this.parrentUrl = this.dataset.parentUrl;
    this.container = document.getElementById('collection-grid-container');
    this.categories = this.querySelectorAll('[data-category-url]');
    this.categoriesContainer = this.querySelector('.categories');
    this.statusRegion = document.querySelector('.category-status');
    this.setUrl();
  }

  get currentUrl () {
    return this.dataset.currentUrl;
  }

  connectedCallback() {
    window.addEventListener('popstate', () => {
      this.dataset.currentUrl = document.location.pathname;
    });

    this.categoriesContainer.addEventListener('scroll', ()=> {
      this.handleScroll();
    })
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-current-url') {
      if(newValue === oldValue) {
        this.dataset.currentUrl = this.dataset.parentUrl;
      }

      this.setActiveState();
      this.renderCollection();
    }
  }

  setUrl() {
    if(this.container && this.categories.length > 0) {
      const selectedMessageTemplate = this.getAttribute('data-selected-message');
      this.categories.forEach(category => {
        category.addEventListener('click', ()=> {
          if (this.statusRegion && selectedMessageTemplate) {
            this.statusRegion.textContent = selectedMessageTemplate.replace('{{ category }}', category.textContent.trim());
          }
          this.dataset.currentUrl = category.dataset.categoryUrl;
        })
      })
    }
  }

  setActiveState () {
    if(this.container && this.categories.length > 0) {
      this.categories.forEach(category => {        
        if (this.currentUrl === category.dataset.categoryUrl) {
          category.classList.add('active')
        } else {
          category.classList.remove('active');
        }
      })
    }
  }

  async renderCollection() {
    if (this.currentUrl !== '') {
      const response = await fetch(this.currentUrl);
      const result = await response.text();
      const html = new DOMParser().parseFromString(result, 'text/html');
      const collectionGrid = html.getElementById('collection-grid-container');
      if (collectionGrid && this.container) {
        this.container.innerHTML = collectionGrid.innerHTML;
        history.pushState({}, '', this.currentUrl);
      }
    }
  }

  handleScroll() {
    const scrollEnd = this.categoriesContainer.scrollWidth - this.categoriesContainer.clientWidth;
    if(this.categoriesContainer.scrollLeft === 0) {
      this.classList.add('on-start');
      this.classList.remove('scrolling');
      this.classList.remove('on-end');
    } else if (this.categoriesContainer.scrollLeft > 10 && this.categoriesContainer.scrollLeft < scrollEnd - 10) {
      this.classList.remove('on-start');
      this.classList.add('scrolling');
      this.classList.remove('on-end');
    } else if (this.categoriesContainer.scrollLeft >= scrollEnd - 10){
      this.classList.remove('on-start');
      this.classList.remove('scrolling');
      this.classList.add('on-end');
    }
  }
}
customElements.define('collection-subcategories', collectionSubcategories)